import type { MultiSelectOption } from '../components/MultiSelect';

/**
 * Distinct-order (pronumber) counts per region from the loaded scheduler legs,
 * so the Regions dropdown counts match the rows the grid shows for that region.
 */
export function countOrdersByRegion(
  legs: { pronumber: number; terminal: string | null }[],
): Map<string, number> {
  const prosByRegion = new Map<string, Set<number>>();
  for (const leg of legs) {
    if (!leg.terminal) continue;
    const pros = prosByRegion.get(leg.terminal) || new Set<number>();
    pros.add(leg.pronumber);
    prosByRegion.set(leg.terminal, pros);
  }
  return new Map(Array.from(prosByRegion, ([region, pros]) => [region, pros.size]));
}

/** Regions dropdown options labeled with their order counts, e.g. "HOUSTON (12)". */
export function buildRegionOptions(
  regions: string[],
  counts: Map<string, number>,
): MultiSelectOption[] {
  return regions.map((region) => ({
    value: region,
    label: `${region} (${counts.get(region) ?? 0})`,
  }));
}
